<template>
  <div class="card" v-if="userInfo">
    <div class="card-header bg-white header-elements-sm-inline">
      <h6 class="card-title fs-18 fw-600">
        <i class="icon-cog3 mr-2 text-primary"></i>
        Account Settings
      </h6>
      <div class="header-elements">
        <button class="btn btn-light mr-2" @click="$router.push('/usermanagement')">Cancel</button>
        <button class="btn btn-primary" @click="submit">Update</button>
      </div>
    </div>

    <div class="card-body">
      <h6 class="fw-600 fs-16">ข้อมูลบัญชี</h6>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">Username</label>
            <input
              type="text"
              class="form-control"
              :value="userInfo.username"
              readonly
            />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <div><label for="">Password</label></div>

            <button class="btn btn-primary" v-b-modal.reset-password-modal>Reset Password</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="status">Status</label>
            <select class="form-control" v-model="userInfo.status" id="status">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="request_approver">Request Approver</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">Role</label>
            <div class="d-flex">
              <label class="radio-inline m-0 mr-2 d-flex">
                <input
                  v-model="userInfo.role"
                  type="radio"
                  class="styled control-primary mr-1"
                  name="role"
                  value="admin"
                  :disabled="user.role === 'admin'"
                />
                Admin
              </label>
              <label class="radio-inline m-0 mr-2 d-flex">
                <input
                  v-model="userInfo.role"
                  type="radio"
                  class="styled control-primary mr-1"
                  name="role"
                  value="user"
                  :disabled="user.role === 'admin'"
                />
                User
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal centered id="reset-password-modal" ref="reset-password-modal" size="sm" title="Reset Password" hide-backdrop no-close-on-backdrop @cancel="resetPassword = null">
      <div class="form-group">
        <label for="new-password">New Password</label>

        <div class="input-group">
          <input type="text" v-model="resetPassword" id="new-password" class="form-control" placeholder="New Password">
          <span class="input-group-append"  @click="generatePassword">
            <span class="input-group-text"><i class="fa fa-refresh"></i></span>
          </span>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import serviceRoutes from '../../service-routes'

export default {
  props: ['user'],
  components: {
    'b-modal': BModal
  },
  directives: {
    'b-modal': VBModal
  },
  data () {
    return {
      isSubmitting: false,
      userInfo: null,
      resetPassword: null
    }
  },
  mounted () {
    this.userInfo = Object.assign({}, this.user)
    setTimeout(() => {
      window.$('.control-primary').uniform({
        wrapperClass: 'mr-2'
      })
    }, 0)
  },
  methods: {
    generatePassword () {
      this.resetPassword = Math.random().toString(36).slice(-8)
    },
    submit () {
      if (this.isSubmitting) return
      this.isSubmitting = true
      serviceRoutes
        .updateUserAccountSetting(this.userInfo._id, {
          role: this.userInfo.role,
          status: this.userInfo.status,
          reset_password: this.resetPassword
        })
        .then(res => {
          // let user = res.data.data
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Update success'
          })
        })
        .catch(() => {
          alert('error')
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style></style>
